module.exports = __webpack_public_path__ + "static/media/Nectec.27607afd.jpg";